'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Responsive = require('./Responsive');

var _Responsive2 = _interopRequireDefault(_Responsive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Responsive2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/dist/commonjs/addons/Responsive/index.js
 ** module id = 3837
 ** module chunks = 0
 **/